<template>
  <div class="packList">

    <!------------- 组件顶部 start -------------->
    <div class="packList_top">

    </div>
    <!------------- end-组件顶部 ------------->

    <!------------- 组件主体 start------------->
    <div class="packList_main">
      <!-------- 主体表格 start------->
      <el-table :data="tableData"
                stripe
                height="800"
                style="width: 100%">
        <el-table-column label="订单ID (新)"
                         prop="id"
                         width="180">
        </el-table-column>
        <el-table-column label="状态"
                         width="180">
          <template slot-scope="scope">
            {{scope.row.status==33?'待打包':'其他'}}
          </template>
        </el-table-column>
        <el-table-column label="申请用户"
                         prop="jjname"
                         width="180">
        </el-table-column>
        <el-table-column label="用户联系方式"
                         prop="jjmobile"
                         width="180">
        </el-table-column>
        <el-table-column label="包裹数量"
                         prop="bgnum">
        </el-table-column>
        <el-table-column label="操作"
                         width="200">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        content="开始打包"
                        placement="right"
                        v-if="scope.row.status == '33'">
              <el-button @click='skipPacliView(scope.row.id)'
                         icon="el-icon-box"
                         type="primary">
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!--------  end-主体表格------->

      <!-------- 表格分页 start------->
      <div class="tab_paging">
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="page"
                       :page-sizes="pageSelect"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pageTotal">
        </el-pagination>
      </div>
      <!-------- end-表格分页------->

    </div>
    <!------------- end-组件主体 ------------>

  </div>
</template>

<script>
import { aptToBePacked } from '@/request/api'
export default {
  name: 'packList',  //组件名称
  //-----------------vue变量储存------------------------//
  data () {
    return {
      tableData: [],
      page: 1,          //当前表格分页
      pageSize: 10,  //一页内容数量
      pageTotal: 100,  //数据总数量
      pageSelect: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],  //可选择的一页数量
    }
  },
  //---------------------------------------------------//

  //-----------------vue方法函数储存------------------------//
  methods: {
    skipPacliView (id) { //进入打包操作界面
      this.$router.replace({
        name: 'PackView',
        query: {
          id: id
        }
      })
    },

    handleSizeChange (val) { //修改每一页数量
      this.pageSize = val
    },

    handleCurrentChange (val) { //修改当前页
      this.$set(this, 'page', val)
    },

    async getAllData () {  //获取所有列表数据
      let res = await aptToBePacked({
        status: '33',
        page: this.page,
        pageSize: this.pageSize
      })
      this.pageTotal = parseInt(res.totalNum)
      this.tableData = res.orderlist
    },
    //---------------------------------------------------//

  },
  created () {
    this.getAllData()
  }
}
</script>

<style lang='scss'>
.packList {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .packList_top {
    width: 100%;
    min-height: 200px;
    margin-bottom: 10px;
    background-color: #fff;
  }
  .packList_main {
    width: 100%;
    height: 80%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 10px 40px;
    .tab_paging {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 50px;
    }
  }
}
</style>